import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Experiencia } from '../components/Experiencia';
import { Diferencial } from '../components/Diferencial';
import { CertificacionPadi } from '../components/CertificacionPadi';
import { Planes } from '../components/Planes';
import { QueIncluye } from '../components/QueIncluye';
import { EntrenamientoPasoAPaso } from '../components/EntrenamientoPasoAPaso';
import { BeneficiosInscripcion } from '../components/BeneficiosInscripcion';
import { Testimonios } from '../components/Testimonios';
import { FAQ } from '../components/FAQ';
import { Acompanamiento } from '../components/Acompanamiento';
import { CTAFinal } from '../components/CTAFinal';
import { ContactoFinal } from '../components/ContactoFinal';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { FloatingShare } from '../components/FloatingShare';
export function Landing() {
  return <main className="min-h-screen bg-brand-background text-white selection:bg-brand-primary selection:text-brand-background" data-id="element-330">
      <Header data-id="element-331" />
      <Hero data-id="element-332" />
      <Experiencia data-id="element-333" />
      <CertificacionPadi data-id="element-334" />
      <Diferencial data-id="element-335" />
      <Testimonios data-id="element-336" />
      <QueIncluye data-id="element-337" />
      <EntrenamientoPasoAPaso data-id="element-338" />
      <BeneficiosInscripcion data-id="element-339" />
      <Planes data-id="element-340" />
      <FAQ data-id="element-341" />
      <Acompanamiento data-id="element-342" />
      <CTAFinal data-id="element-343" />
      <ContactoFinal data-id="element-344" />
      <FloatingWhatsApp data-id="element-345" />
      <FloatingShare data-id="element-346" />
    </main>;
}